import { Task, TaskDefinition, } from "multitool-sdk-core";
export class BrowserWorkerTaskDefinition extends TaskDefinition {
    worker;
    constructor(opts) {
        super(opts);
        this.worker = opts.worker;
    }
    async run(task) {
        this.worker.port.postMessage(JSON.stringify({ type: "task", task }));
    }
}
//# sourceMappingURL=BrowserWorkerTaskDefinition.js.map